export { default } from './CampaignConsent';
